import React from "react";

const Support247 = () => {
  return (
    <div className="min-h-screen bg-slate-50 font-sans pt-12 pb-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Hero Section */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h1 className="text-3xl sm:text-5xl font-black text-slate-900 tracking-tight mb-4">
            We’re here to help, 24/7.
          </h1>
          <p className="text-slate-500 text-lg font-medium">
            Whether you have a question about your booking or need urgent
            assistance while traveling, our human experts are always ready.
          </p>
        </div>

        {/* Quick Action Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
          {[
            {
              title: "Call Us Now",
              desc: "Speak directly with an agent. No hold times.",
              action: "1-888-977-1997",
              icon: "📞",
            },
            {
              title: "Live Chat",
              desc: "Chat instantly with our support team online.",
              action: "Start Chat",
              icon: "💬",
            },
            {
              title: "Manage Booking",
              desc: "Change dates, cancel, or upgrade flights.",
              action: "Go to My Trips",
              icon: "✈️",
            },
          ].map((card, idx) => (
            <div
              key={idx}
              className="bg-white rounded-3xl p-8 shadow-sm border border-slate-100 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 text-center group cursor-pointer"
            >
              <div className="text-4xl mb-4 group-hover:scale-110 transition-transform">
                {card.icon}
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-2">
                {card.title}
              </h3>
              <p className="text-slate-500 text-sm mb-6">{card.desc}</p>
              <span className="text-blue-600 font-bold group-hover:text-blue-800 transition-colors">
                {card.action} →
              </span>
            </div>
          ))}
        </div>

        {/* Common FAQs */}
        <div className="max-w-4xl mx-auto bg-white rounded-3xl shadow-sm border border-slate-100 p-8 sm:p-10">
          <h2 className="text-2xl font-bold text-slate-900 mb-8">
            Frequently Asked Questions
          </h2>
          <div className="space-y-6">
            {[
              {
                q: "How do I cancel my flight?",
                a: "You can cancel your flight directly through the 'Manage Booking' portal. Cancellation fees depend on your specific airline's fare rules.",
              },
              {
                q: "What happens if my flight is delayed?",
                a: "We monitor flights 24/7. If your flight is delayed or canceled, we will automatically notify you and help rebook you on the next available option.",
              },
              {
                q: "Can I correct a name on my ticket?",
                a: "Minor name corrections (up to 3 letters) are usually free. Please call our 24/7 support line immediately to process the change before departure.",
              },
            ].map((faq, idx) => (
              <div
                key={idx}
                className="border-b border-slate-100 pb-6 last:border-0 last:pb-0"
              >
                <h4 className="text-lg font-bold text-slate-900 mb-2">
                  {faq.q}
                </h4>
                <p className="text-slate-500 text-sm leading-relaxed">
                  {faq.a}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Support247;
